import {useTranslation} from "react-i18next";
import FormFieldBox from "../../common/form/FormFieldBox";
import TextInput from "../../common/form/TextInput";
import FormRow from "../../common/form/FormRow";
import React from "react";
import {Control} from "react-hook-form";

type Props = {
    index: number
    control: Control<any>
}


export const BlfNotificationDelayTimeForm = ({ index, control }: Props) => {
    const { t } = useTranslation()

    return (<FormRow>
        <FormFieldBox>
            <TextInput
                readonly={false}
                label={t('users.edit.blf-time-before-pickup-notification')}
                name={`fieldUpdates.${index}.values.0.stringValue`}
                control={control}
                required={true}
            />
        </FormFieldBox>
    </FormRow>)
}